import React, { useEffect, useState } from "react";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { Loading } from "../Loading";
import axiosInstance from "../../../axios";
import { buildCourseDetailsURI } from "../../../_helpers";
import { getS3URL } from "../../../_helpers";
import "./search.css";
import { useDispatch } from "react-redux";

const courseCategories = [
  "All Courses",
  "Finance",
  "Uncategorized",
  "Adult Content",
  "Languages",
  "Art & Design",
  "Broadcasting",
  "Politics",
  "Sports",
  "Food & Nutrition",
  "Style & Beauty",
  "Home & Gardening",
  "Engineering",
  "Post Secondary",
  "Academics & Education",
  "Music & Dance",
  "Health & Fitness",
  "Video & Photography",
  "LifeStyle",
  "Sales & Marketing",
  "IT & Software",
  "Development",
  "Business",
];

const courseCategories2 = [
  "All Courses",
  "Finance",
  "Uncategorized",
  "Adult Content",
  "Languages",
  "Art & Design",
  "Broadcasting",
  "Politics",
  "Sports",
  "Food & Nutrition",
  "Style & Beauty",
  "Home & Gardening",
  "Engineering",
  "Post Secondary",
  "Academics & Education",
  "Music & Dance",
  "Health & Fitness",
  "Video & Photography",
  "LifeStyle",
  "Sales & Marketing",
  "IT & Software",
  "Development",
  "Business",
  "Consultant",
  "Business Administration",
  "Entrepreneurship",
  "Finance",
  "Marketing",
  "Management, Organisation & Leadership",
  "Mobile App Development",
  "Web Programming/Web Design",
  "Data Analytics",
  "DevOps",
  "UI/UX Framework Development",
  "Database Administrator (DBA)",
  "Accounting & BookKeeping",
  "Money Management Tools",
  "Stock trading",
  "Software Engineering",
  "IT Certification",
  "IT and Tech",
  "Programming Language",
  "Network Security",
  "Computer science",
  "Sales",
  "Real Estate",
  "Travel",
  "Vocal",
  "Personel well being",
  "Fitness",
  "Dieting & Nurition",
  "Gaming",
  "Video Videography + Production",
  "Digital Photography",
  "Photography Tools",
  "Portraits",
];

const Search = ({ history, variant, setFilter }) => {
  const [query, setQuery] = useState("");
  const [inputValue, setInputValue] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [showAutoComplete, setShowAutocomplete] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const fetchSuggestions = (value, type) => {
    setQuery(value);
    if (value.length > 3) {
      setShowAutocomplete(true);
      axiosInstance
        .get(`/search/course?search=${value}${type ? `&type=${type}` : ""}`)
        .then(({ data }) => {
          setSuggestions(
            data?.data?.length > 0
              ? data?.data?.map((course) => ({
                  name: course.CourseName,
                  id: course.ID,
                  subCategory: course.Category,
                  imageFiles: course.imageFiles,
                  description: course.description,
                  EnrollmentFee: course.EnrollmentFee,
                }))
              : [{ name: "No Records Found" }]
          );
        });
    } else {
      setShowAutocomplete(false);
    }
  };

  const handleFocus = (suggestions) => {
    if (suggestions.length > 0 && query.length > 3) {
      setShowAutocomplete(true);
    }
  };

  const handleChangeDebounce = debounce(
    (value) => fetchSuggestions(value, variant),
    500
  );

  useEffect(() => {
    return () => handleChangeDebounce.cancel();
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      const searchInput = document.getElementById("course-search");
      const autoComplete = document.getElementById("auto-complete");
      if (searchInput && autoComplete) {
        const isClickInside = searchInput.contains(event.target)
          ? true
          : autoComplete.contains(event.target)
          ? false
          : false;

        if (!isClickInside) {
          setShowAutocomplete(false);
        } else {
          setInputValue(null);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  const handleFormSubmit = (event, query) => {
    event.preventDefault();
    setFilter({
      fliterCategory: inputValue,
      fliterLevel: null,
      filterSubCategory: null,
    });

    setShowAutocomplete(false);
  };
  return (
    <>
      <form
        id="contact-form"
        onSubmit={(event) => handleFormSubmit(event, query)}
      >
        <div className="form-group">
          <div className="input-wrapper">
            <input
              id="course-search"
              type="text"
              name="inputValue"
              value={inputValue}
              placeholder={t("Hello")}
              className="form-control"
              aria-label="Search"
              autoComplete="off"
              onChange={(event) => handleChangeDebounce(event.target.value)}
              onFocus={() => handleFocus(suggestions)}
              required
            />{" "}
            <div className="button-wrapper">
              <button
                type="submit"
                aria-label="button"
                className="btn btn-submit"
              ></button>
            </div>
          </div>
        </div>
      </form>
      <AutoComplete
        isActive={showAutoComplete}
        dispatch={dispatch}
        query={query}
        history={history}
        input={inputValue}
        setFilter={setFilter}
        suggestions={suggestions}
        setInputValue={setInputValue}
        showSuggestions={setShowAutocomplete}
      />
    </>
  );
};

export const SearchBar = withRouter(Search);

const AutoComplete = ({
  isActive,
  query,
  suggestions,
  history,
  dispatch,
  setFilter,
  input,
  setInputValue,
}) => {
  const filteredArray = courseCategories2?.filter((item) =>
    item.toLowerCase().includes(query)
  );

  const handleListClick = (item) => {
    const dummy = courseCategories?.filter((data) =>
      data.toLowerCase().includes(item.toLowerCase())
    );

    setInputValue(item);
    history.push({
      pathname: "/courses",
      state: {
        filterCourse: dummy.length > 0 ? item : null,
        subCourses: dummy.length > 0 ? null : item,
      },
    });
  };

  const getHighlightedText = (text, highlight) => {
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <span>
        {parts &&
          parts?.map((part, index) =>
            part?.toLowerCase() === highlight?.toLowerCase() ? (
              <span style={{ fontWeight: "bold" }} key={index}>
                {part}
              </span>
            ) : (
              part
            )
          )}
      </span>
    );
  };
  return isActive ? (
    <div className="search-suggestions" id="auto-complete">
      {
        filteredArray.length > 0 ?  <div className="search-category-title">Category  &  Sub-Category :</div> : ""
      }

      {suggestions?.length > 0 ? (
        <ul>
          <div>
            {filteredArray?.length > 0 &&
              filteredArray?.map((item, index) => {
                return (
                  <div className={!item ? "search-list" : "search-tags"}>
                    {item ? (
                      <li key={index} onClick={() => handleListClick(item)}>
                        {item}
                      </li>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}
          </div>
          <div className="search-title">SEARCH RESULTS FOR :</div>
          {suggestions?.map((suggestion, index) => (
            <div className="filterSearchMain" key={index}>
              <li className="searchFilter-suggestionList">
                {suggestion?.imageFiles?.length > 0 && (
                  <div>
                    <img
                      className="filterSearchImage"
                      src={getS3URL(
                        suggestion?.imageFiles?.length > 0 &&
                          suggestion?.imageFiles[0]?.fileName
                      )}
                    />
                  </div>
                )}
                <div>
                  <a
                    href={buildCourseDetailsURI(
                      suggestion?.subCategory,
                      suggestion?.name,
                      suggestion?.id
                    )}
                  >
                    {getHighlightedText(suggestion.name, query)}

                    <span className="search-EnrollmentFee">
                      {suggestion?.EnrollmentFee? `${suggestion?.EnrollmentFee}`: ""}
                    </span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: suggestion?.description?.substring(0, 200),
                      }}
                    ></span>
                  </a>
                </div>
              </li>
            </div>
          ))}
        </ul>
      ) : (
        <Loading />
      )}
    </div>
  ) : null;
};
